<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

<lib-side-nav *ngIf="!hideNav" [selectedItem]="selectedItem" [navHeader]="navHeader" [items]="items"
  [appConfig]="appConfig"></lib-side-nav>
